import React from 'react';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import HandymanIcon from '@mui/icons-material/Handyman';
import BuildIcon from '@mui/icons-material/Build';
import DevicesIcon from '@mui/icons-material/Devices';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PetsIcon from '@mui/icons-material/Pets';
import CelebrationIcon from '@mui/icons-material/Celebration';
import YardIcon from '@mui/icons-material/Yard';
import SecurityIcon from '@mui/icons-material/Security';
import BusinessIcon from '@mui/icons-material/Business';
import GavelIcon from '@mui/icons-material/Gavel';
import SchoolIcon from '@mui/icons-material/School';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import PoolIcon from '@mui/icons-material/Pool';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import PersonIcon from '@mui/icons-material/Person';
import CategoryIcon from '@mui/icons-material/Category';
import type { SvgIconComponent } from '@mui/icons-material';
import { SERVICE_CATEGORY_UI_MAPPINGS } from './serviceCategoryDbMapping';

const HERO_CATEGORY_ICON_SX = { fontSize: '1.35rem' } as const;

/** Colors aligned with ServiceIcons CATEGORY_COLORS (MUI-only hero path). */
const HERO_CATEGORY_COLORS: Record<string, string> = {
    'Cleaning Services': '#26A69A',
    'Home Improvement & Renovation': '#FF6B6B',
    'Handyman & Repairs': '#4FC3F7',
    'Assembly & Installation': '#42A5F5',
    'Tech & Electronics': '#7E57C2',
    'Moving & Hauling': '#FFA726',
    'Shopping & Delivery': '#66BB6A',
    'Auto Services': '#1976D2',
    'Health, Wellness & Care': '#EC407A',
    'Pet Care': '#AB47BC',
    'Event Services': '#FFD54F',
    'Seasonal & Outdoor Maintenance': '#66BB6A',
    'Home Safety & Security': '#5C6BC0',
    'Office & Workspace': '#78909C',
    'Legal & Financial Services': '#26A69A',
    'Education & Lessons': '#42A5F5',
    'Property & Environmental Services': '#8D6E63',
    'Pool & Spa Services': '#00ACC1',
    'Exterior & Structural': '#795548',
    'Clothing Alteration & Tailoring': '#F06292',
    'Personal & Lifestyle': '#90A4AE',
};

const HERO_CATEGORY_MUI_ICONS: Record<string, SvgIconComponent> = {
    'Cleaning Services': CleaningServicesIcon,
    'Home Improvement & Renovation': HomeRepairServiceIcon,
    'Handyman & Repairs': HandymanIcon,
    'Assembly & Installation': BuildIcon,
    'Tech & Electronics': DevicesIcon,
    'Moving & Hauling': LocalShippingIcon,
    'Shopping & Delivery': ShoppingCartIcon,
    'Auto Services': DirectionsCarIcon,
    'Health, Wellness & Care': FavoriteIcon,
    'Pet Care': PetsIcon,
    'Event Services': CelebrationIcon,
    'Seasonal & Outdoor Maintenance': YardIcon,
    'Home Safety & Security': SecurityIcon,
    'Office & Workspace': BusinessIcon,
    'Legal & Financial Services': GavelIcon,
    'Education & Lessons': SchoolIcon,
    'Property & Environmental Services': EnergySavingsLeafIcon,
    'Pool & Spa Services': PoolIcon,
    'Exterior & Structural': HomeRepairServiceIcon,
    'Clothing Alteration & Tailoring': CheckroomIcon,
    'Personal & Lifestyle': PersonIcon,
};

function resolveDatabaseCategory(categoryName: string): string {
    const t = categoryName.trim();
    const row = SERVICE_CATEGORY_UI_MAPPINGS.find(
        (r) =>
            r.databaseCategory.toLowerCase() === t.toLowerCase()
            || r.displayName.toLowerCase() === t.toLowerCase(),
    );
    return row?.databaseCategory ?? t;
}

/** MUI icon for a hero search row — no Font Awesome on the critical path. */
export function getHeroCategoryMuiIcon(categoryName: string): React.ReactNode {
    const databaseCategory = resolveDatabaseCategory(categoryName);
    const Icon = HERO_CATEGORY_MUI_ICONS[databaseCategory] ?? CategoryIcon;
    const color = HERO_CATEGORY_COLORS[databaseCategory] ?? '#90A4AE';
    return <Icon sx={{ ...HERO_CATEGORY_ICON_SX, color }} />;
}
